import { Grid2, Typography } from "components";

export const AllocationTypeTooltipContent = () => {
  return (
    <Grid2 container spacing={2}>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          Allocation:{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            Allocate new/fresh funds in a model or a company
          </span>
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          Rebalance:{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            Rebalance client’s portfolio or single company in the client’s
            portfolio
          </span>
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          Exit:{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            Exit or sell from a client’s portfolio or a single company in the
            client’s portfolio
          </span>
        </Typography>
      </Grid2>
    </Grid2>
  );
};

export const AllocationByTooltipContent = ({
  allocationType,
}: {
  allocationType: string;
}) => {
  return allocationType === "exit" ? (
    <Grid2 container spacing={2}>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          Model:{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            This option would create orders to exit all the assets in the model
            present in the portfolio according to the specified weightage.
          </span>
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          Portfolio:{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            This option would create orders to exit all the assets present in
            the portfolio according to the specified weightage.
          </span>
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          Company-Absolute:{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            This option would create orders to exit the specified weightage of
            the asset from its total present holdings in the portfolio.
          </span>
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          Company-Relative:{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            This option would create exit/sell orders in order for the asset to
            reach the specified weightage in the portfolio.
          </span>
        </Typography>
      </Grid2>
    </Grid2>
  ) : (
    <Grid2 size={12}>
      <Typography fontSize={12} fontWeight={600} color="#333">
        Select your base for order creation, a model or a company.
      </Typography>
    </Grid2>
  );
};

export const ModelReferenceWeightage = () => {
  return (
    <Grid2 container spacing={2}>
      <Grid2 size={12}>
        <Typography fontWeight={400} fontSize={12}>
          Select your model weightage preference to be used for order creation
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          Allocated:{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            This represents the intended or target weightage of each asset in
            your portfolio at the time of creation of your model portfolio or at
            the time of your last rebalance.
          </span>
        </Typography>{" "}
      </Grid2>
      <Grid2 size={12}>
        <Typography>
          <Typography fontSize={12} fontWeight={600} color="#333">
            Current:{" "}
            <span style={{ fontWeight: 400, fontSize: 12 }}>
              This represents the actual distribution of assets in your
              portfolio at the current time. It reflects how the market value of
              your holdings has evolved due to changes in prices or
              contributions/withdrawals.
            </span>
          </Typography>
        </Typography>
      </Grid2>
    </Grid2>
  );
};

export const ReferenceValueTooltip = ({
  allocationType,
}: {
  allocationType: string;
}) => {
  return (
    <Grid2 container spacing={2}>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          {allocationType === "allocation"
            ? "Committed value"
            : "Current value"}
          :{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            {allocationType === "allocation"
              ? "The capital that the client has agreed to invest in a given portfolio, this option will also consider the existing holdings of the asset while creating the orders."
              : "Current value refers to the total present holding value of the portfolio, this option will create orders in order to adjust the asset allocations within the portfolio to align it with target weightages in the model, it won’t use any extra available funds as a part of the rebalance."}
          </span>
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          {allocationType === "allocation"
            ? "Committed value"
            : "Portfolio value "}
          :{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            {allocationType === "allocation"
              ? "This option will not consider the existing holdings of the asset while creating the orders, it will straight away allocate funds on the basis of the total committed value."
              : "Portfolio value refers to the total present holding value of the portfolio plus the available ledger balance, this option will create orders in order to adjust the asset allocations within the portfolio to align it with target weightages in the model, it can use extra available funds(available ledger balance) as a part of the rebalance."}
          </span>
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          {allocationType === "allocation"
            ? "Ledger balance"
            : "Committed value"}
          :{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            {allocationType === "allocation"
              ? " This option will use the available ledger balance to allocate funds while creating orders."
              : "The capital that the client has agreed to invest in a given portfolio, this option will create orders in order to adjust the asset allocations according to the committed value to align it with target weightages in the model."}
          </span>
        </Typography>
      </Grid2>
    </Grid2>
  );
};

export const ReferenceValueCompanyTooltip = () => {
  return (
    <Grid2 container spacing={2}>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          Current value:{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            Current value refers to the total present holding value of the
            portfolio, this option will create orders in order to achieve the
            specified weightage for the company(selected in the next step) w.r.t
            the current holdings of the portfolio.
          </span>
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          Portfolio value:{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            Portfolio value refers to the total present holding value of the
            portfolio plus the available ledger balance, this option will create
            orders in order to achieve the specified weightage for the
            company(selected in the next step) w.r.t the portfolio value of the
            portfolio.
          </span>
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          Committed value:{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            The capital that the client has agreed to invest in a given
            portfolio, this option will also consider the existing holdings of
            the asset while creating the orders.
          </span>
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          Committed value - Absolute:{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            This option will not consider the existing holdings of the asset
            while creating the orders, it will straight away allocate funds on
            the basis of the total committed value.
          </span>
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          Ledger balance:{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            This option will use the available ledger balance to allocate funds
            while creating orders.
          </span>
        </Typography>
      </Grid2>
    </Grid2>
  );
};

export const WeightageDistributionMethod = () => {
  return (
    <Grid2 container spacing={2}>
      <Grid2 size={12}>
        <Typography fontWeight={400} fontSize={12}>
          This is relevant only when you recalculate your order after putting
          certain assets(which are being bought as a part of the order) on hold.
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          Prorata:{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            Selecting this option will redistribute the hold amount into the
            other assets being bought in a prorata basis according to the
            allocation weightages.
          </span>
        </Typography>{" "}
      </Grid2>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          No Redistribution:{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            Selecting this option will not redistribute the hold amount into
            other assets and add this amount to the ledger balance.
          </span>
        </Typography>{" "}
      </Grid2>
    </Grid2>
  );
};

export const ExitReferenceValueCompanyTooltip = () => {
  return (
    <Grid2 container spacing={2}>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          Current value:{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            Current value refers to the total present holding value of the
            portfolio, this option will create exit orders in order to achieve
            the specified weightage for the company(selected in the next step)
            w.r.t the current holdings of the portfolio.
          </span>
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          Portfolio value:{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            Portfolio value refers to the total present holding value of the
            portfolio plus the available ledger balance, this option will create
            exit orders in order to achieve the specified weightage for the
            company(selected in the next step) w.r.t the portfolio value of the
            portfolio.
          </span>
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={600} color="#333">
          Committed value:{" "}
          <span style={{ fontWeight: 400, fontSize: 12 }}>
            The capital that the client has agreed to invest in a given
            portfolio, this option will create exit orders in order to achieve
            the specified weightage for the company(selected in the next step)
            w.r.t the portfolio value of the portfolio.
          </span>
        </Typography>
      </Grid2>
    </Grid2>
  );
};
